module.exports = __webpack_public_path__ + "media/entities/2314-53aba74f.png";